webpackJsonp([7],{

/***/ 499:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Shared_ContactView__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Shared_NavbarView__ = __webpack_require__(501);


var contactView = new __WEBPACK_IMPORTED_MODULE_0__Shared_ContactView__["a" /* ContactView */]();
var navbarView = new __WEBPACK_IMPORTED_MODULE_1__Shared_NavbarView__["a" /* NavbarView */]();


/***/ }),

/***/ 500:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ContactView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Core_Helpers_Uri__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__brightspark_sparkling_ajax_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__brightspark_sparkling_ajax_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__brightspark_sparkling_ajax_js__);



var Action;
(function (Action) {
    Action[Action["GetContact"] = 0] = "GetContact";
})(Action || (Action = {}));
var ContactView = /** @class */ (function () {
    function ContactView() {
        this.SetupVue();
    }
    ContactView.prototype.SetupVue = function () {
        var v = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
            el: ".get-contact",
            data: {
                success: false,
                fullName: "",
                email: "",
                content: "",
                errors: new Array()
            },
            methods: {
                contact: function () {
                    var data = {
                        FullName: v.fullName,
                        Email: v.email,
                        Content: v.content
                    };
                    __WEBPACK_IMPORTED_MODULE_2__brightspark_sparkling_ajax_js__(__WEBPACK_IMPORTED_MODULE_1__Core_Helpers_Uri__["a" /* Uri */].getUri(Action[Action.GetContact]), { dataType: "json", method: "post", data: data })
                        .done(function (res) {
                        if (!res) {
                            return;
                        }
                        if (res.success) {
                            v.success = true;
                        }
                        else {
                            v.errors = res.errors;
                        }
                    });
                }
            }
        });
    };
    return ContactView;
}());



/***/ }),

/***/ 501:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NavbarView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(7);

var NavbarView = /** @class */ (function () {
    function NavbarView() {
        this.SetupVue();
    }
    NavbarView.prototype.SetupVue = function () {
        var v = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
            el: "#navbar",
            data: {
                menu: {
                    open: false
                }
            }
        });
    };
    return NavbarView;
}());



/***/ })

},[499]);


// WEBPACK FOOTER //
// js/shared.bundle.js